import { React, useState } from 'react';
import {
	Widget,
	addResponseMessage,
	toggleMsgLoader,
	setQuickButtons,
	addUserMessage,
	toggleInputDisabled,
	dropMessages,
} from 'react-chat-widget';
import axios from 'axios';
import { useEffect } from 'react';
import { useContext } from 'react';
import { ViewContext } from 'components/lib';
import Styles from './HelperChat.module.scss'

/**
 * HelperChat component for displaying a chat widget.
 * @param {object} props - Component props.
 * @param {boolean} [props.active=true] - Flag to determine if the chat widget is active or not. Default is true
 * @param {string} props.topic - The topic related to the chat.
 * @returns {JSX.Element} HelperChat component.
 */
export function HelperChat({ active = true, topic }) {
	const viewContext = useContext(ViewContext);
	const [placeHolder, setPlaceHolder] = useState(viewContext.t('Components.HelperChat.placeholder.default'));

	useEffect(() => {
		dropMessages()
		addResponseMessage(
			`${viewContext.t('Components.HelperChat.message.welcome', { topic })}`,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [topic]);

	const handleNewUserMessage = async (newMessage) => {

		toggleMsgLoader();

		toggleInputDisabled();

		const formData = {
			question: newMessage,
			topic: ` ${topic}`
		};

		const options = {
			method: 'POST',
			url: `/api/ai/chat`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};
		await axios
			.request(options)
			.then(function (response) {
				toggleMsgLoader();
				addResponseMessage(response?.data?.data.toString());
				toggleInputDisabled();
			})
			.catch((err) => {

				toggleMsgLoader();
				setPlaceHolder(viewContext.t('Components.HelperChat.placeholder.error'));
				toggleInputDisabled();
				toggleInputDisabled();
				viewContext.notification.show(err.response.message, 'error', true);
			});
	};

	const handleQuickButtonClicked = (message) => {
		addUserMessage(message);
		addResponseMessage(message);
		setQuickButtons([]);
	};

	return (
		active &&
		<>
			<div
				id="chatCompContainer"
				className={Styles.chatContainer}
			>
				<Widget
					id="chatWidget"
					handleNewUserMessage={handleNewUserMessage}
					title="AiVa"
					subtitle={viewContext.t('Components.HelperChat.subtitle')}
					sendButtonAlt={viewContext.t('Components.HelperChat.button')}
					handleQuickButtonClicked={handleQuickButtonClicked}
					showCloseButton={true}
					senderPlaceHolder={placeHolder}
					profileAvatar={'https://tgt1institute.blob.core.windows.net/topos-icons/Labs/chat/chat_robot_icon.png'}
					profileClientAvatar={'https://tgt1institute.blob.core.windows.net/topos-icons/Labs/chat/chat_user_icon.png'}
				/>
			</div>
			<style>
				{`
					.rcw-conversation-container > .rcw-header {
						background-color: #1450a0 ;
                        height: 10vh;
                        align-items: flex-start;
                        justify-content: flex-start;
                        padding: 0;
					}

                    .rcw-launcher {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #1450a0
                    }

                    .rcw-conversation-container .rcw-title {
                        font-size: 1.4em;
                        margin-left: 0.4em;
                        padding: 0;
                    }
                    .rcw-conversation-container .rcw-header span {
                        margin-left: 0.4em
                    }
                    .rcw-conversation-container .rcw-sender {
                        justify-content: space-evenly;
                        flex-direction: row;
                        align-items: center;
                    }

                    .rcw-input {
                        max-height: 3em;
                        max-width: 100%;
						color: black
                    }

                    .rcw-client .rcw-message-text {
                        background-color: lightgrey;
                        color: black;
						min-width: 20em;
						max-width: 30em;
                    }
                    .rcw-response .rcw-message-text {
                        background-color: lightblue;
                        color: black;
						white-space: pre-wrap;
						min-width: 20em;
						max-width: 30em;
        		    }

					.rcw-picker-btn {
						display: none
					}

					.rcw-new-message {
						width: 30em;
    					margin-right: 0.3em;
						cursor: text
					}
				`}
			</style>
		</>
	);
}
